import { useQuery } from '@tanstack/react-query';
import { AccountBillingService } from 'src/services/account-billing-information';

type UseGetBillingInformationStatusArgs = {
  customerId: string;
  enabled?: boolean;
  refetchOnMount?: boolean;
};

export const BILLING_INFORMATION_STATUS_QUERY_KEY = 'billingInformationStatus';

export const useGetBillingStatusQuery = ({
  customerId,
  enabled = true,
  refetchOnMount = false,
}: UseGetBillingInformationStatusArgs) => {
  const {
    data: billingInformationStatus,
    isLoading,
    isFetching,
    dataUpdatedAt,
  } = useQuery({
    queryKey: [BILLING_INFORMATION_STATUS_QUERY_KEY, customerId],
    queryFn: () => AccountBillingService.getBillingStatus(customerId),
    staleTime: 0,
    refetchOnMount,
    refetchOnWindowFocus: false,
    enabled: !!customerId && enabled,
  });

  return { billingInformationStatus, isLoading, isFetching, dataUpdatedAt };
};
